class UnsupportedBrowserDC {
  public COOKIE_VALUE = 'never-show-up-today';
}

export default new UnsupportedBrowserDC();
